import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./components/AuthProvider";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthPage from "./pages/AuthPage";
import CoffreFortPage from "./pages/CoffreFortPage";
import "./App.css";
import BienDetailsPage from "./pages/BienDetailsPage";
import Footer from "./components/Footer";

// Composant pour gérer la redirection automatique
const AppRoutes: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#E9ECEF",
        }}
      >
        <div
          style={{
            width: "40px",
            height: "40px",
            border: "4px solid #CED4DA",
            borderTop: "4px solid #b4840e",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/auth"
        element={user ? <Navigate to="/coffre-fort" replace /> : <AuthPage />}
      />
      <Route
        path="/coffre-fort"
        element={
          <ProtectedRoute>
            <CoffreFortPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/bien-details/:bienId"
        element={
          <ProtectedRoute>
            <BienDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/bien-details/:bienId/historique"
        element={
          <ProtectedRoute>
            <BienDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/bien-details/:bienId/travaux"
        element={
          <ProtectedRoute>
            <BienDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/bien-details/:bienId/gestion-courante"
        element={
          <ProtectedRoute>
            <BienDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={<Navigate to={user ? "/coffre-fort" : "/auth"} replace />}
      />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <AppRoutes />
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
